// removed by extract-text-webpack-plugin
module.exports = {"event-list":"_2RX5K4Qh_ _2l0xl0HVf _2cxE75SKM _8QSagsfVR _252nX0Tjy","title":"jzmrOFNjy _1yJuXbiru _1FTxuUfut _1yThnDgzj _3-7RXEMuO _3-BezK0d_ _1C-lRJLgc xBrMYP3IH _2OFVW-wzu _1-ov2DQLe YXYmy67R7 _2HOZDFp6P _2_tabFk6j ODSLv4a7K _2BH_6_kaD _3_Hs_uunq _3aEWL7amJ","subtitle":"_3hWKmrN5s _2gtf48bQr _1yJuXbiru _1FTxuUfut _1yThnDgzj _1BE2U7F8v _1C-lRJLgc _1gaUFCwDT _2OFVW-wzu _1-ov2DQLe YXYmy67R7 _2HOZDFp6P _2_tabFk6j _2tvY6e7Hw _3oZepBe3o"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/event-list/event-list.css
 ** module id = 2107
 ** module chunks = 0
 **/